module.exports = __webpack_public_path__ + "img/city-sillouhette.541467e9.png";